export class advisorProfileModel {
    name: string = '';
    role: string = '';
    avatar: string = 'images/avatar_male_unknown.png';
    status: advisorStatus = 0;
    phone: string = '';
}

export enum advisorStatus {
    Offline = 0,
    Online = 1
}